
import { Component, Vue } from "vue-property-decorator";
import AnonymousLayout from "@/layouts/AnonymousLayout.vue";
@Component({
  components: {AnonymousLayout}
})
export default class Logout extends Vue {
  private logoutId = '';
  
  $refs!: {
    form: HTMLFormElement
  }
  
  created() {
    this.logoutId = this.$route.query.logoutId as string||
        this.$route.query.LogoutId as string||
        '';
  }
  
  mounted() {
    this.$refs.form.submit();
  }
}
